import { useId, type InputHTMLAttributes } from 'react'

import estilos from './Formulario.module.css'

type PropsCampo = Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> & {
  etiqueta: string
  /** Texto de apoyo bajo el campo. Se oculta cuando hay error. */
  ayuda?: string
  error?: string
  obligatorio?: boolean
  /** Alinea a la derecha con ancho tabular: para horas y pesos. */
  numerico?: boolean
}

/**
 * Entrada de texto con su etiqueta, su ayuda y su error.
 *
 * El identificador se genera solo: así la etiqueta siempre queda amarrada a
 * su campo, incluso cuando el mismo formulario se repite en una lista.
 */
export function Campo({
  etiqueta,
  ayuda,
  error,
  obligatorio = false,
  numerico = false,
  className,
  ...resto
}: PropsCampo) {
  const id = useId()
  const idAyuda = `${id}-ayuda`

  const clases = [estilos.control, numerico ? estilos.numerico : '', error ? estilos.conError : '', className ?? '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={estilos.campo}>
      <label className={estilos.etiqueta} htmlFor={id}>
        {etiqueta}
        {obligatorio && (
          <span className={estilos.obligatorio} aria-hidden="true">
            *
          </span>
        )}
      </label>

      <input
        id={id}
        className={clases}
        required={obligatorio}
        aria-invalid={Boolean(error)}
        aria-describedby={error || ayuda ? idAyuda : undefined}
        {...resto}
      />

      {error ? (
        <span id={idAyuda} className={estilos.error}>
          {error}
        </span>
      ) : (
        ayuda && (
          <span id={idAyuda} className={estilos.ayuda}>
            {ayuda}
          </span>
        )
      )}
    </div>
  )
}
